import * as React from 'react';
import { ToastContainer } from 'react-toastify';

type Props = {};

const CustomToastContainer = () => {
    return (
        <ToastContainer
            autoClose={5000}
            bodyClassName="laToastBody"
            className="laToastContainer"
            closeOnClick
            pauseOnHover
            position="top-right"
            progressClassName="laToastProgress"
            toastClassName="laToastToast"
        />
    );
};

export default CustomToastContainer;
